import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useApp } from "../context/AppContext";
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { checkAuth } = useApp();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Confirming your payment...");
  const orderId = useMemo(() => searchParams.get("orderId") || "", [searchParams]);
  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!orderId) {
        setStatus("error");
        setMessage("Missing order reference.");
        return;
      }
      for (let i = 0; i < 10; i += 1) {
        try {
          const res = await axios.get(`/api/payment/order/${encodeURIComponent(orderId)}`);
          const s = String(res.data?.status || "").toLowerCase();
          if (s === "completed" || s === "paid") {
            await checkAuth();
            if (cancelled) return;
            setStatus("success");
            setMessage("Payment confirmed and your plan is active.");
            return;
          }
          if (s === "failed" || s === "cancelled" || s === "expired") {
            if (cancelled) return;
            setStatus("error");
            setMessage("Payment was not completed.");
            return;
          }
        } catch {
        }
        await new Promise((resolve) => setTimeout(resolve, 1500));
      }
      if (!cancelled) {
        setStatus("pending");
        setMessage("Payment received. Activation may take a few seconds, please refresh shortly.");
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [orderId, checkAuth]);
  return <div className="full-screen-center" style={{ textAlign: "center", gap: 12 }}>
      <h1 style={{ margin: 0 }}>{status === "success" ? "Payment Success" : status === "error" ? "Payment Issue" : "Processing Payment"}</h1>
      <p style={{ margin: 0, color: "var(--text-3)", maxWidth: 480 }}>{message}</p>
      <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
        <button className="btn-primary" onClick={() => navigate("/chat")}>Go to Chat</button>
        <button className="btn-ghost" onClick={() => navigate("/settings")}>Open Settings</button>
      </div>
    </div>;
};
var stdin_default = PaymentSuccess;
export {
  stdin_default as default
};
